import PropTypes from 'prop-types';

import styleSheet from './poll.module.scss';

import { getImageUrl } from '../../helpers/images';

const styles = styleSheet.locals || {};

/**
 * Component for the poll sponsor
 *
 * @param {object} props poll option props
 * @param {object} props.poll poll option data
 * @param {boolean} props.isVisible - footer sponsor visible, to decrease complexity of main components
 * @returns {Function} <PollSponsor />
 */
function PollSponsor({ poll, isVisible = true }) {
    const hasSponsorImg =
        poll?.sponsor_image_url || poll?.sponsor_external_image_url;

    if (!hasSponsorImg || !isVisible) {
        return null;
    }
    /* eslint-disable no-magic-numbers */

    const sponsorUrl = poll?.sponsor_url;

    const isValidUrl = (url) => {
        try {
            new URL(url);
            return true;
            /* eslint-disable-next-line id-length */
        } catch (_) {
            return false;
        }
    };

    const validUrl = isValidUrl(sponsorUrl);

    const renderSponsorImage = () => {
        if (poll?.sponsor_image_url) {
            return (
                <img
                    part="potg-sponsor-image"
                    src={getImageUrl(poll.sponsor_image_url, 160)}
                    alt={poll.sponsor_image_text || ''}
                    className={styles.pollSponsorImage}
                    data-testid={'poll-sponsor-image-manual'}
                />
            );
        }

        if (poll?.sponsor_external_image_url) {
            return (
                <img
                    part="potg-sponsor-image"
                    src={poll.sponsor_external_image_url}
                    alt={poll.sponsor_image_text || ''}
                    className={styles.pollSponsorImage}
                    data-testid={'poll-sponsor-image-automated'}
                />
            );
        }

        return null;
    };

    return (
        <div
            part="potg-sponsor"
            data-cy="sponsorLabel"
            className={styles.pollSponsor}
            data-testid="poll-sponsor"
        >
            {poll.sponsor_label ? (
                <div
                    part="potg-sponsor-label"
                    className={styles.pollSponsorLabel}
                >
                    {poll.sponsor_label}
                </div>
            ) : (
                ''
            )}

            {validUrl ? (
                <a href={sponsorUrl} target="_blank" rel="noopener noreferrer">
                    {renderSponsorImage()}
                </a>
            ) : (
                renderSponsorImage()
            )}
        </div>
    );
}

PollSponsor.propTypes = {
    poll: PropTypes.object.isRequired,
    isVisible: PropTypes.bool
};

export default PollSponsor;
